function openConsultation(id) {
  window.open(`/consultations/${id}`);
}

export default openConsultation;